import { render, staticRenderFns } from "./ibcMatchInfo.vue?vue&type=template&id=5e312f6c&scoped=true&lang=pug&"
import script from "./ibcMatchInfo.vue?vue&type=script&lang=js&"
export * from "./ibcMatchInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e312f6c",
  null
  
)

export default component.exports